module.exports = __webpack_public_path__ + "img/Image 14.e449688e.png";